import validate from 'lib/utils/validationRules';

const getTimezoneAreaList = state => state.timezoneList.map(timezone => timezone.area);

const getCurrentTimezoneAreaId = state => state.currentTimezoneArea?.id || null;

const getCurrentTimezoneAreaCode = state => state.currentTimezoneArea?.code || null;

const getTimezoneListMapByAreaGroup = state => {
  const timezoneListMap = state.timezoneList.reduce((acc, curr) => {
    acc[curr.area.code] = curr.zones;
    return acc;
  }, {});

  return timezoneListMap;
};

const getCurrentAreaTimezoneList = (state, getters) => {
  const { getCurrentTimezoneAreaCode, getTimezoneListMapByAreaGroup } = getters;

  if (!validate.isObjectWithFields(getTimezoneListMapByAreaGroup, [getCurrentTimezoneAreaCode])) {
    return [];
  }

  return getTimezoneListMapByAreaGroup[getCurrentTimezoneAreaCode];
};

export default {
  getTimezoneAreaList,
  getCurrentTimezoneAreaId,
  getCurrentTimezoneAreaCode,
  getTimezoneListMapByAreaGroup,
  getCurrentAreaTimezoneList,
};
